/**
 * A component that displays a colored status tag with text
 * 
 * @param {object} props - The component props
 * @param {string} props.text - The text to display inside the tag
 * @param {string} props.color - Simple color name ('red', 'green', 'gray') or custom CSS color value
 * @param {string} props.className - Optional CSS class name to override default styling
 * @returns {JSX.Element} A styled status tag component
 */
export const StatusTag = ({ text, color, className }) => {
  // Map simple colors to hex values
  const colorMap = {
    red: "#db3234",
    green: "#b2d9cb",
    gray: "#616161",
    lightgray: "#dfdfdf"
  };

  // Get the background color from the map or use the provided color directly
  const backgroundColor = colorMap[color.toLowerCase()] || color;
  
  // Use black text for green background, white for others
  const textColor = color.toLowerCase() === 'green' ? 'black' : 'white';

  return (
    <div 
      className={`h-6 px-3 rounded flex items-center justify-center text-[12px] text-center ml-6 mb-1 ${className || ''}`}
      style={{ 
        backgroundColor, 
        color: textColor 
      }}
    >
      {text}
    </div>
  )
}
